import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import { Card, Icon, Divider, Image, Button, Label, Grid, Segment, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { compose } from 'recompose';

import TelegramChannelAddModal from './telegram-channel-add';
import hasUserInfo from '../../../hocs/has-user-info';
import { useStore } from 'react-redux';

const cf = num => numeral(num).format('0,0');
const TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
const TELEGRAM_CHANNEL_API = `${TELEGRAM_API_BASE_URL}/telegram/channel`;
const TELEGRAM_CHATS_API = `${TELEGRAM_API_BASE_URL}/telegram/chats`;
const TELEGRAM_BASE_URL = 'https://t.me/';


const DeleteButton = props =>
  <Button
    size="mini"
    onClick={props.handler}
    compact
    circular
    floated={props.floated}
    icon="delete"
  />;

DeleteButton.propTypes = {
  handler: PropTypes.func.isRequired,
  floated: PropTypes.string.isRequired,
};

const centered = {
  textAlign: 'center',
};

class TelegramChannels extends React.Component {
  constructor() {
    super();
    this.state = {
      showAddModal: false,
      isSearching: false,
      isSearchError: false,
      channelData: null,
      addedChannels: [],
      removedChannels: [],
      newUser: null,
      addType: 'USER',
    };
  }

  closeAddModal = () => {
    console.log('close');
    this.setState({
      showAddModal: false,
    });
  }

  toggleAddUserModal = () => {
    console.log('user');
    const { showAddModal } = this.state;

    const newValue = !showAddModal;
    this.setState({
      showAddModal: newValue,
      channelData: null,
      addType: 'USER',
    });
  }

  toggleAddChannelModal = () => {
    const { showAddModal } = this.state;

    const newValue = !showAddModal;
    this.setState({
      showAddModal: newValue,
      channelData: null,
      addType: 'CHANNEL',
    });
  }

  getTelegramAddChannelUrl = influencerId => {
    const url = `${TELEGRAM_API_BASE_URL}/influencer/${influencerId}/telegram/channels`;
    return url;
  };

  getPrivateTelegramAddChannelUrl = influencerId => {
    const url = `${TELEGRAM_API_BASE_URL}/influencer/${influencerId}/telegram/privateChannels`;
    return url;
  };

  getTelegramRemoveChannelUrl = (influencerId, channelId) => {
    const url = `${TELEGRAM_API_BASE_URL}/influencer/${influencerId}/telegram/channels/${channelId}`;
    return url;
  };

  searchTelegramChannel = _.debounce(async (event, { value }) => {
    console.log('searchTelegramChannel');
    const lowerValue = _.toLower(value);
    const channelUrl = _.replace(lowerValue, TELEGRAM_BASE_URL, '');
    const searchUrl = `${TELEGRAM_CHANNEL_API}/${channelUrl}`;
    console.log(searchUrl);
    await this.setState({
      channelData: null,
      isSearching: true,
    });
    const response = await axios.get(searchUrl);
    const { data: { data } } = response;
    console.log(data);
    await this.setState({
      channelData: data,
      isSearching: false,
    });
  }, 1000)

  addPrivateTelegramChannel = async data => {
    console.log('addPrivateTelegramChannel');
    const { channelData, addedChannels, addType } = this.state;
    const { influencer, userInfo } = this.props;
    const addPrivateChannelUrl = this.getPrivateTelegramAddChannelUrl(influencer.id);

    const payload = {
      title: data.title,
      createdBy: _.get(userInfo, 'name'),
      accessHash: data.accessHash ? _.toString(data.accessHash) : 'no_accessHash',
      id: _.toString(data.id),
      username: data.username || 'no_username',
    };

    payload.createdBy = _.get(userInfo, 'name');


    console.log(userInfo);
    console.log(payload);


    await this.setState({
      isSearching: true,
    });

    const response = await axios.post(addPrivateChannelUrl, payload).then(r => r.data.data);
    const { channel } = response;
    console.log(channel);
    const chan = channel.attributes;
    chan.id = channel.id;

    addedChannels.push(chan);
    await this.setState({
      showAddModal: false,
      isSearching: false,
      error: false,
      addedChannels,
    });
  }

  addTelegramChannel = async () => {
    console.log('addTelegramChannel');
    const { channelData, addedChannels, addType } = this.state;
    const { typeInfo } = channelData;
    const { influencer, userInfo } = this.props;

    const addChannelUrl = this.getTelegramAddChannelUrl(influencer.id);
    const payload = {
      channelData,
      userInfo,
    };

    await this.setState({
      isSearching: true,
    });
    const response = await axios.post(addChannelUrl, payload).then(r => r.data.data);
    const { channel } = response;
    const chan = channel.attributes;
    chan.id = channel.id;

    if (_.get(typeInfo, 'type') === 'USER') {
      await this.setState({
        showAddModal: false,
        isSearching: false,
        newUser: chan,
        error: false,
      });
    } else {
      addedChannels.push(chan);
      await this.setState({
        showAddModal: false,
        isSearching: false,
        error: false,
        addedChannels,
      });
    }
  }


  deleteTelegramChannel = async (influencerId, channelId) => {
    const { removedChannels } = this.state;
    console.log(`delete channel ${channelId} from influencer ${influencerId}`);
    const url = this.getTelegramRemoveChannelUrl(influencerId, channelId);
    const response = await axios.delete(url);
    console.log(response);
    removedChannels.push(channelId);
    await this.setState({
      removedChannels,
    });
  }

  deleteTelegramUser = async (influencerId, channelId) => {
    const { removedChannels } = this.state;
    console.log(`delete channel ${channelId} from influencer ${influencerId}`);
    const url = this.getTelegramRemoveChannelUrl(influencerId, channelId);
    const response = await axios.delete(url);
    console.log(response);
    removedChannels.push(channelId);
    await this.setState({
      newUser: { id: 'xxx' },
    });
  }

  render() {
    const { channels, influencer, user } = this.props;
    const { showAddModal, isSearching, channelData, addedChannels, removedChannels, newUser, addType } = this.state;
    const displayUser = newUser || user;
    console.log('TelegramChannels');
    console.log(channels);
    console.log(user);
    let resultingChannels = _.concat(channels, addedChannels);
    // reject channels that have been removed
    resultingChannels = _.reject(resultingChannels, rc => _.includes(removedChannels, rc.id));
    // const users = _.filter(resultingChannels, rc => _.isEqual(rc.channelType, 'USER'));
    const availableChannels = _.filter(resultingChannels, rc => _.get(rc, 'channelType'));

    return (
      <Segment color="blue">
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <h3>
                <Icon name="telegram" size="large" color="blue" />TELEGRAM
              </h3>
              <Divider />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row divided>
            <Grid.Column width={4}>
              <Card.Group>
                { displayUser && _.isEqual(displayUser.channelType, 'USER') &&
                <Card style={centered}>
                  <Card.Content>
                    <Image
                      size="small"
                      src={displayUser.thumbnail}
                      className="circular"
                    />
                    <Divider />
                    <h4>
                      {displayUser.displayName}
                    </h4>
                    <h5>
                      <Label basic color="blue">{displayUser.channelType}</Label>
                    </h5>
                    {
                      displayUser.followerCount &&
                      <h6 style={{ padding: 10 }}>
                        {cf(displayUser.followerCount)} {displayUser.channelType.match(/GROUP/) ? 'members' : 'subscribers'}
                      </h6>
                    }
                    <p style={{ fontSize: '80%' }}>
                      {_.truncate(displayUser.bio, { length: 100 })}
                    </p>
                  </Card.Content>
                  <Card.Content extra>
                    <DeleteButton
                      displayName={displayUser.displayName}
                      influencerName={influencer.name}
                      handler={() => this.deleteTelegramUser(influencer.id, displayUser.id)}
                      floated="right"
                    />
                    <Button
                      circular
                      compact
                      size="mini"
                      icon="edit"
                      floated="right"
                      onClick={this.toggleAddUserModal}
                    />
                    <a
                      href={`https://t.me/${user.channelUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >{user.channelUrl}</a>
                  </Card.Content>
                </Card>
                }
                { (!displayUser || !_.isEqual(displayUser.channelType, 'USER')) && <Card style={centered}>
                  <Card.Content>
                    <div style={{ minHeight: 300, paddingTop: 100 }}>
                      <Button circular icon="add" color="blue" size="massive" inverted onClick={this.toggleAddUserModal} />
                      <div>&nbsp;</div>
                      <h4>ADD User</h4>
                    </div>
                  </Card.Content>
                </Card>}
              </Card.Group>
            </Grid.Column>
            <Grid.Column width={12}>
              <Card.Group>
                {
                  _.map(availableChannels, c => (
                    <Card style={centered}>
                      <Card.Content>
                        <Image
                          size="small"
                          src={c.thumbnail}
                          className="circular"
                        />
                        <Divider />
                        <h4>
                          {c.displayName}
                        </h4>
                        <h5>
                          <Label basic color="blue">{c.channelType}</Label>
                        </h5>
                        {
                          c.followerCount &&
                          <h6 style={{ padding: 10 }}>
                            {cf(c.followerCount)} {c.channelType.match(/GROUP/) ? 'members' : 'subscribers'}
                          </h6>
                        }
                        <p style={{ fontSize: '80%' }}>
                          {_.truncate(c.bio, { length: 100 })}
                        </p>
                      </Card.Content>
                      <Card.Content extra>
                        <DeleteButton
                          displayName={c.displayName}
                          influencerName={influencer.name}
                          handler={() => this.deleteTelegramChannel(influencer.id, c.id)}
                          floated="right"
                        />
                        <a
                          href={`https://t.me/${c.channelUrl}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >{c.channelUrl}</a>
                      </Card.Content>
                    </Card>
                  ))
                }
                <Card style={centered}>
                  <Card.Content>
                    <div style={{ minHeight: 300, paddingTop: 100 }}>
                      <Button circular icon="add" color="blue" size="massive" inverted onClick={this.toggleAddChannelModal} />
                      <div>&nbsp;</div>
                      <h4>ADD CHANNEL</h4>
                    </div>
                  </Card.Content>
                </Card>
              </Card.Group>
              {
                showAddModal &&
                <TelegramChannelAddModal
                  onClose={this.closeAddModal}
                  searchTelegramChannel={this.searchTelegramChannel}
                  isLoading={isSearching}
                  channelData={channelData}
                  handleAddChannel={this.addTelegramChannel}
                  handleAddPrivateChannel={this.addPrivateTelegramChannel}
                  type={addType}
                />
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

TelegramChannels.propTypes = {
  influencer: PropTypes.object.isRequired,
  channels: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

export default compose(
  hasUserInfo,
)(TelegramChannels);



/** WEBPACK FOOTER **
 ** ./src/components/influencer-profile-stats/components/telegram-channels.js
 **/